/* Cart drawer wording and the free-shipping progress bar.

   The drawer's layout and colour are handled in CSS by sections/cart-skin.liquid.
   This file rewrites the copy the theme renders from its own translations --
   the heading with a live count, and the empty state's title, subtitle and
   button -- draws the progress bar under the header, and puts all of it back
   whenever the theme re-renders the drawer after a cart change. */
(function(){
"use strict";

var TAG = document.currentScript || document.querySelector("script[data-cart-skin]");
if (!TAG) return;

var HEADING = TAG.getAttribute("data-heading") || "Your bag";
var EMPTY = TAG.getAttribute("data-empty") || "";
var SUB = TAG.getAttribute("data-sub") || "";
var CTA = TAG.getAttribute("data-cta") || "";
var CTA_URL = TAG.getAttribute("data-cta-url") || "";

var SHIP = TAG.getAttribute("data-ship") === "true";
var GOAL = Math.round(parseFloat(TAG.getAttribute("data-ship-goal") || "0") * 100);
/* Nobody wants to be told they are three cents short. Anything within this
   much of the goal is treated as having reached it. */
var TOL = Math.round(parseFloat(TAG.getAttribute("data-ship-tolerance") || "0") * 100);
var AWAY = TAG.getAttribute("data-ship-away") || "You're {amount} away from free shipping";
var DONE = TAG.getAttribute("data-ship-done") || "Free shipping unlocked";

/* Anything this file or its neighbours write into the drawer. Changes inside
   these are ours, and must never start another round of work. */
var OURS = ".cart-skin__ship, .cart-skin__sub, .cart-upsell, .ec-cart-note";

function drawer(){ return document.getElementById("CartDrawer"); }

/* The header bubble is the theme's own source of truth and is re-rendered on
   every cart change; the quantity inputs are the fallback while it catches up. */
function count(){
  var bubble = document.querySelector(".cart-count-bubble span[aria-hidden], .cart-count-bubble span");
  if (bubble){
    var n = parseInt((bubble.textContent || "").replace(/\D/g, ""), 10);
    if (!isNaN(n)) return n;
  }
  var qty = document.querySelectorAll('#CartDrawer input[name="updates[]"]');
  var t = 0;
  for (var i=0;i<qty.length;i++) t += parseInt(qty[i].value, 10) || 0;
  return t;
}

function money(cents, currency){
  try {
    return new Intl.NumberFormat(undefined, { style:"currency", currency:currency || "USD" }).format(cents/100);
  } catch(e){
    return (cents/100).toFixed(2);
  }
}

function words(){
  var d = drawer();
  if (!d) return;

  var h = d.querySelector(".drawer__heading");
  if (h){
    var want = HEADING + " (" + count() + ")";
    if (h.textContent.trim() !== want) h.textContent = want;
  }

  var empty = d.querySelector(".cart-drawer__empty-content");
  if (!empty) return;

  var title = empty.querySelector(".cart__empty-text");
  if (title && EMPTY && title.textContent.trim() !== EMPTY) title.textContent = EMPTY;

  if (SUB && title && !empty.querySelector(".cart-skin__sub")){
    var p = document.createElement("p");
    p.className = "cart-skin__sub";
    p.textContent = SUB;
    title.insertAdjacentElement("afterend", p);
  }

  var btn = empty.querySelector("a.button");
  if (btn){
    if (CTA && btn.textContent.trim() !== CTA) btn.textContent = CTA;
    if (CTA_URL && btn.getAttribute("href") !== CTA_URL) btn.setAttribute("href", CTA_URL);
  }
}

/* The bar sits between the header and the items, and only while there is
   something in the bag -- an empty cart has its own screen to make. */
function bar(cart){
  var d = drawer();
  if (!d || !SHIP || !GOAL) return;
  var header = d.querySelector(".drawer__header");
  if (!header) return;

  var el = d.querySelector(".cart-skin__ship");
  if (!cart.item_count){
    if (el && el.parentNode) el.parentNode.removeChild(el);
    return;
  }

  if (!el){
    el = document.createElement("div");
    el.className = "cart-skin__ship";
    var p = document.createElement("p");
    p.className = "cart-skin__ship-text";
    var track = document.createElement("div");
    track.className = "cart-skin__bar";
    track.appendChild(document.createElement("span"));
    el.appendChild(p);
    el.appendChild(track);
    header.insertAdjacentElement("afterend", el);
  }

  var total = cart.total_price || 0;
  var left = Math.max(0, GOAL - total);
  var reached = left <= TOL;
  var text = reached ? DONE : AWAY.replace("{amount}", money(left, cart.currency));
  var node = el.querySelector(".cart-skin__ship-text");
  if (node.textContent !== text) node.textContent = text;
  el.classList.toggle("is-done", reached);
  el.querySelector(".cart-skin__bar > span").style.width =
    reached ? "100%" : Math.max(3, Math.min(99, Math.round(total / GOAL * 100))) + "%";
}

/* The cart is only re-read when it can actually have changed. Without this a
   stray DOM change -- someone opening a dropdown in the recommendations, say
   -- would cost a round trip and the panel would feel sticky. */
var busy = false, last = 0, cached = null;
function refresh(force){
  words();
  if (!SHIP || !GOAL || busy) return;
  var now = Date.now();
  if (!force && cached && now - last < 800){ bar(cached); return; }
  busy = true;
  fetch("/cart.js", { headers:{ "Accept":"application/json" }, credentials:"same-origin" })
    .then(function(r){ return r.json(); })
    .then(function(c){ if (c){ cached = c; last = Date.now(); bar(c); } })
    .catch(function(){})
    .then(function(){ busy = false; });
}

function start(){
  refresh(true);
  var d = drawer();
  if (!d) return;
  var pending = null;
  var mo = new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      var t = muts[i].target;
      var node = t && t.nodeType === 1 ? t : (t && t.parentElement);
      if (node && node.closest && node.closest(OURS)) continue;
      clearTimeout(pending);
      pending = setTimeout(function(){ refresh(true); }, 60);
      return;
    }
  });
  mo.observe(d, { childList:true, subtree:true, characterData:true });
  /* The bubble lives outside the drawer, so the count is refreshed on open. */
  document.addEventListener("click", function(ev){
    if (ev.target.closest && ev.target.closest("#cart-icon-bubble, a[href$='/cart']")) setTimeout(function(){ refresh(true); }, 80);
  }, true);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();

})();

/* Colour-match warning: Tough MagSafe case + the power bank of the same design.

   Which items qualify is decided in Liquid (snippets/ec-cart-finish-note.liquid);
   this asks for it through sections/ec-cart-note.liquid and shows it two ways:

   - a pop-up the customer has to dismiss, shown when the cart is open (drawer
     or /cart page) and again if they press Checkout without having seen it;
   - a note at the top of the cart items, so it stays visible afterwards.

   The wording comes from the "Cart drawer skin" section settings (the
   data-cw-* attributes on its script tag); {design} is the design name.

   Once dismissed it does not come back for the same designs in this visit; a
   new matching design brings it back. The theme re-renders the cart on every
   change, so the note is put back each time and only re-fetched when the
   cart's contents actually changed. */
(function(){
"use strict";

var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
var SECTION = "ec-cart-note";
var ACK_KEY = "ec-finish-ack";

var TAG = document.querySelector("script[data-cart-skin]");
function setting(name, fallback){
  var v = TAG && TAG.getAttribute("data-cw-" + name);
  return v == null || v === "" ? fallback : v;
}
var NOTE_TEXT = setting("note", "");
var POPUP = setting("popup", "true") !== "false";
var POP_TITLE = setting("title", "Heads up on colour");
var POP_TEXT = setting("text", "{design}: your Tough MagSafe case is printed on a different finish than the power bank, so the colours can differ by around 20%. For the closest match, choose the Gold lens or Silver lens case.");
var POP_OK = setting("ok", "Got it");
var POP_CHECKOUT = setting("checkout", "Continue to checkout");
var CHANGE_ATTR = TAG && TAG.getAttribute("data-cw-change");
var POP_CHANGE = CHANGE_ATTR == null ? "Change my case finish" : CHANGE_ATTR;   /* blank hides the button */

/* Writes text into el, with every {design} replaced by the names in bold. */
function fill(el, text, names){
  el.textContent = "";
  var parts = String(text).split("{design}");
  for (var i=0;i<parts.length;i++){
    if (i > 0){
      var b = document.createElement("strong");
      b.textContent = names;
      el.appendChild(b);
    }
    if (parts[i]) el.appendChild(document.createTextNode(parts[i]));
  }
}

var node = null;       /* the note for the current cart, or null for none */
var sig = null;        /* cart contents the note was fetched for */
var busy = false, again = false;

function store(k, v){
  try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch(e){}
  return null;
}
function designs(){ return node ? (node.getAttribute("data-designs") || "x") : ""; }
var ackMem = "";       /* fallback if sessionStorage is blocked */
function acked(){ return !node || !POPUP || ackMem === designs() || store(ACK_KEY) === designs(); }
function ack(){ if (node){ ackMem = designs(); store(ACK_KEY, ackMem); } }

function targets(){
  var out = [];
  var d = document.getElementById("CartDrawer-CartItems");
  if (d) out.push(d);
  var p = document.querySelector("#main-cart-items .js-contents");
  if (p) out.push(p);
  return out;
}

function cartVisible(){
  if (document.querySelector("#main-cart-items .cart-items")) return true;
  var cd = document.querySelector("cart-drawer");
  return !!(cd && cd.classList.contains("active"));
}

/* Variant + quantity of every line currently drawn. Cheap, and it changes
   exactly when the cart does. */
function signature(){
  var parts = [];
  var t = targets();
  for (var i=0;i<t.length;i++){
    var q = t[i].querySelectorAll("input[data-quantity-variant-id]");
    for (var j=0;j<q.length;j++) parts.push(q[j].getAttribute("data-quantity-variant-id") + ":" + q[j].value);
  }
  return parts.sort().join(",");
}

function place(){
  var t = targets();
  for (var i=0;i<t.length;i++){
    var el = t[i];
    var have = el.querySelector(".ec-cart-note");
    if (!node){ if (have && have.parentNode) have.parentNode.removeChild(have); continue; }
    if (have) continue;
    var at = el.querySelector(".drawer__cart-items-wrapper") || el.querySelector("table.cart-items");
    if (!at) continue;             /* empty cart */
    var copy = node.cloneNode(true);
    var p = copy.querySelector("p");
    if (p && NOTE_TEXT) fill(p, NOTE_TEXT, node.getAttribute("data-designs") || "");
    at.insertAdjacentElement("beforebegin", copy);
  }
  if (!node) close();
  else if (POPUP && !acked() && cartVisible()) open(null);
}

/* ---------- pop-up ---------- */

var modal = null, pendingCheckout = null;

function css(){
  if (document.getElementById("ec-finish-modal-css")) return;
  var s = document.createElement("style");
  s.id = "ec-finish-modal-css";
  s.textContent =
    ".ec-fm{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:2rem;background:rgba(18,18,18,.45);animation:ecFmIn .18s ease}" +
    ".ec-fm[hidden]{display:none}" +
    ".ec-fm__box{width:100%;max-width:40rem;background:#fff;color:#121212;border-radius:1.4rem;padding:2.6rem 2.4rem 2.2rem;box-shadow:0 2rem 6rem rgba(0,0,0,.25);text-align:left;font-family:inherit}" +
    ".ec-fm__icon{width:4rem;height:4rem;border-radius:50%;background:var(--ec-fm-soft,#FAF6EE);color:var(--ec-fm-accent,#8A6D2F);display:flex;align-items:center;justify-content:center;margin-bottom:1.4rem}" +
    ".ec-fm__icon svg{width:2.2rem;height:2.2rem}" +
    ".ec-fm__title{margin:0 0 .8rem;font-size:1.9rem;font-weight:600;line-height:1.25;letter-spacing:0}" +
    ".ec-fm__text{margin:0 0 2rem;font-size:1.4rem;line-height:1.55;color:#4a4a4a}" +
    ".ec-fm__text strong{color:#121212}" +
    ".ec-fm__actions{display:flex;flex-direction:column;gap:.9rem}" +
    ".ec-fm__btn{display:flex;align-items:center;justify-content:center;min-height:4.8rem;padding:0 2rem;border-radius:999px;font:inherit;font-size:1.2rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;text-decoration:none;cursor:pointer;border:1px solid #121212}" +
    ".ec-fm__btn[hidden]{display:none}" +
    ".ec-fm__btn--primary{background:#121212;color:#fff}" +
    ".ec-fm__btn--ghost{background:#fff;color:#121212}" +
    "@keyframes ecFmIn{from{opacity:0}to{opacity:1}}" +
    "@media (max-width:749px){.ec-fm{align-items:flex-end;padding:0}.ec-fm__box{max-width:none;border-radius:1.6rem 1.6rem 0 0;padding:2.4rem 2rem calc(2rem + env(safe-area-inset-bottom,0px))}}";
  document.head.appendChild(s);
}

function build(){
  css();
  modal = document.createElement("div");
  modal.className = "ec-fm";
  modal.hidden = true;
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("aria-labelledby", "ec-fm-title");
  modal.innerHTML =
    '<div class="ec-fm__box">' +
      '<div class="ec-fm__icon"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
        '<circle cx="10" cy="10" r="8.2" stroke="currentColor" stroke-width="1.5"/>' +
        '<path d="M10 9v5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
        '<circle cx="10" cy="6.2" r="1.05" fill="currentColor"/></svg></div>' +
      '<h2 class="ec-fm__title" id="ec-fm-title"></h2>' +
      '<p class="ec-fm__text"></p>' +
      '<div class="ec-fm__actions">' +
        '<button type="button" class="ec-fm__btn ec-fm__btn--primary" data-ec-ok></button>' +
        '<a class="ec-fm__btn ec-fm__btn--ghost" data-ec-change href="#"></a>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);

  modal.querySelector("[data-ec-ok]").addEventListener("click", function(){
    ack();
    var btn = pendingCheckout;
    close();
    if (btn) btn.click();          /* acknowledged, so it goes straight through */
  });
  modal.querySelector("[data-ec-change]").addEventListener("click", function(){ ack(); });
  document.addEventListener("keydown", function(ev){
    if (ev.key === "Escape" && modal && !modal.hidden){ ev.stopPropagation(); ack(); close(); }
  }, true);
}

function open(checkoutBtn){
  if (!node) return;
  if (!modal) build();
  pendingCheckout = checkoutBtn || null;
  var names = node.getAttribute("data-designs") || "your design";
  modal.querySelector(".ec-fm__title").textContent = POP_TITLE;
  fill(modal.querySelector(".ec-fm__text"), POP_TEXT, names);
  modal.querySelector("[data-ec-ok]").textContent = checkoutBtn ? POP_CHECKOUT : POP_OK;
  var url = node.getAttribute("data-url");
  var change = modal.querySelector("[data-ec-change]");
  change.textContent = POP_CHANGE;
  change.hidden = !url || !POP_CHANGE;
  if (url) change.setAttribute("href", url);
  if (modal.hidden){
    modal.hidden = false;
    setTimeout(function(){ var f = modal.querySelector("[data-ec-ok]"); if (f) f.focus(); }, 30);
  }
}

function close(){
  if (modal) modal.hidden = true;
  pendingCheckout = null;
}

/* Checkout is the last chance: if the customer never opened the cart long
   enough to see the pop-up, it is shown before they leave. */
document.addEventListener("click", function(ev){
  var btn = ev.target.closest && ev.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"]');
  if (!btn || acked()) return;
  ev.preventDefault();
  ev.stopImmediatePropagation();
  open(btn);
}, true);

/* ---------- fetching ---------- */

function refresh(){
  var s = signature();
  if (s === sig){ place(); return; }
  if (busy){ again = true; return; }
  if (!s){ sig = s; node = null; place(); return; }
  busy = true;
  fetch(ROOT + "?sections=" + SECTION, { credentials:"same-origin" })
    .then(function(r){ return r.json(); })
    .then(function(data){
      var box = document.createElement("div");
      box.innerHTML = (data && data[SECTION]) || "";
      node = box.querySelector(".ec-cart-note");
      sig = s;
      place();
    })
    .catch(function(){})
    .then(function(){
      busy = false;
      if (again){ again = false; refresh(); }
    });
}

var timer = null;
function soon(){ clearTimeout(timer); timer = setTimeout(refresh, 80); }

function ours(n){
  return n && n.nodeType === 1 && (n.classList.contains("ec-cart-note") || (n.closest && n.closest(".ec-cart-note")));
}

function start(){
  refresh();
  var mo = new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      var m = muts[i];
      if (ours(m.target)) continue;
      var mine = true, k;
      for (k=0;k<m.addedNodes.length;k++) if (!ours(m.addedNodes[k])) mine = false;
      for (k=0;k<m.removedNodes.length;k++) if (!ours(m.removedNodes[k])) mine = false;
      if (mine && (m.addedNodes.length || m.removedNodes.length)) continue;
      soon();
      return;
    }
  });
  var hosts = [document.getElementById("CartDrawer"), document.getElementById("main-cart-items")];
  for (var i=0;i<hosts.length;i++) if (hosts[i]) mo.observe(hosts[i], { childList:true, subtree:true });

  /* The drawer opening is a class change on <cart-drawer>, not a re-render. */
  var cd = document.querySelector("cart-drawer");
  if (cd) new MutationObserver(function(){
    if (cd.classList.contains("active")) soon();
  }).observe(cd, { attributes:true, attributeFilter:["class"] });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();

})();

/* One cart: the side drawer.

   The full /cart page is never shown. sections/ec-cart-redirect.liquid sends
   any visit to /cart back to the page the shopper came from (or home) and
   leaves a flag; this opens the drawer when that page loads. It also catches
   links to /cart anywhere on the site and opens the drawer in place, so most
   of the time the redirect is never needed. */
(function(){
"use strict";

var FLAG = "ec-open-cart";
var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
var CART = ROOT.replace(/\/$/, "") + "/cart";

function flag(v){
  try {
    if (v === undefined){ var f = sessionStorage.getItem(FLAG); sessionStorage.removeItem(FLAG); return f; }
    sessionStorage.setItem(FLAG, v);
  } catch(e){}
  return null;
}

function openDrawer(from){
  if (!window.customElements) return false;
  var el = document.querySelector("cart-drawer");
  if (!el) return false;
  customElements.whenDefined("cart-drawer").then(function(){
    var d = document.querySelector("cart-drawer");
    if (d && typeof d.open === "function") d.open(from || undefined);
  });
  return true;
}

/* Arrived here from a /cart visit. */
function arrive(){
  var want = flag() === "1" || /(^|&)ec_cart=1(&|$)/.test(location.search.slice(1));
  if (!want) return;
  if (/(^|[?&])ec_cart=1/.test(location.search) && window.history && history.replaceState){
    var clean = location.pathname + location.search.replace(/([?&])ec_cart=1&?/, "$1").replace(/[?&]$/, "") + location.hash;
    history.replaceState(history.state, "", clean);
  }
  openDrawer();
}

/* Any plain link to the cart page opens the drawer instead. */
document.addEventListener("click", function(ev){
  if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
  var a = ev.target.closest && ev.target.closest("a[href]");
  if (!a || a.id === "cart-icon-bubble") return;   /* the theme already handles the bag icon */
  var url;
  try { url = new URL(a.getAttribute("href"), location.href); } catch(e){ return; }
  if (url.origin !== location.origin) return;
  var path = url.pathname.replace(/\/$/, "");
  if (path !== CART && path !== "/cart") return;
  if (openDrawer(a)) ev.preventDefault();
}, false);

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arrive);
else arrive();

})();

/* Bundle "Add to cart" without leaving the page.

   MBC Bundles is set to send shoppers to /cart after adding a bundle, which
   reloads the page. Here its after-add action is switched to "stay on the
   current page" in the browser, and once the app has finished adding (the
   add itself, then the cart update it uses for the bundle discount) the
   theme's own drawer is re-rendered and opened -- the same thing the theme
   does for a normal Add to cart. Only requests made just after a bundle
   button press are watched, so the theme's own add-to-cart is untouched. */
(function(){
"use strict";

var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
var armed = 0, added = false, timer = null;

function stay(){
  try {
    var g = window.MAKEBECOOL_BUNDLES.shop.settings.global;
    if (g.actionAfterAddToCart !== "stayOnCurrentPage") g.actionAfterAddToCart = "stayOnCurrentPage";
    return true;
  } catch(e){ return false; }
}
(function tick(n){ if (!stay() && n < 60) setTimeout(function(){ tick(n + 1); }, 250); })(0);

document.addEventListener("click", function(ev){
  if (ev.target.closest && ev.target.closest(".mbc-bundle__atc, .mbc-bundle__button")){
    stay();
    armed = Date.now() + 15000;
    added = false;
  }
}, true);

function render(){
  var cd = document.querySelector("cart-drawer");
  if (!cd || typeof cd.renderContents !== "function") return;
  window.fetch(ROOT + "?sections=cart-drawer,cart-icon-bubble", { credentials:"same-origin" })
    .then(function(r){ return r.json(); })
    .then(function(sections){
      if (sections && sections["cart-drawer"]) cd.renderContents({ id: null, sections: sections });
    })
    .catch(function(){});
}
function soon(wait){ clearTimeout(timer); timer = setTimeout(render, wait); }

var native = window.fetch;
if (native){
  window.fetch = function(input, init){
    var p = native.apply(this, arguments);
    if (Date.now() < armed){
      try {
        var url = String(typeof input === "string" ? input : (input && input.url) || "").split("?")[0];
        if (/\/cart\/add(\.js)?$/.test(url)){
          p.then(function(r){ if (r && r.ok){ added = true; soon(700); } }, function(){});
        } else if (added && /\/cart\/(update|change)(\.js)?$/.test(url)){
          p.then(function(){ soon(250); }, function(){ soon(250); });
        }
      } catch(e){}
    }
    return p;
  };
}

})();
